<template>
  <div class="resolution-ui-wrapper">
    <v-alert text type="warning">
      The vendor review UI has not yet been implemented. Click the button below
      to go to the old onboarding page. You'll have to navigate to the specific
      vendor again because we can't link directly to the specific vendor review
      UI yet.
    </v-alert>
    <v-btn color="primary" href="/client/manage/onboard">
      Go to Old Onboarding Page
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "VendorReviewResolutionUI"
};
</script>

<style scoped></style>
